import { render } from "./ManualSbpQrLinkEditor.vue?vue&type=template&id=f0ede966&scoped=true&ts=true"
import script from "./ManualSbpQrLinkEditor.vue?vue&type=script&lang=ts"
export * from "./ManualSbpQrLinkEditor.vue?vue&type=script&lang=ts"

import "./ManualSbpQrLinkEditor.vue?vue&type=style&index=0&id=f0ede966&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0ede966"]])

export default __exports__